export const parseNumberString = (x: number | string | undefined) => {
    if (x === "" || x === undefined || x === null) {
        return "";
    }

    x = Number(x) || 0; // remove any leading 0

    return `${x}`;
};
